/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Import all the third party stuff
import React, { useEffect } from 'react';
import App from './containers/App';

/* eslint-enable */
export default function Mount() {
  useEffect(() => {
    document.title = 'Capacity';
  }, []);
  return <App />;
}
